// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Jjax9","label":"Section_label__2rLTZ","contentWrap":"Section_contentWrap__1nr_9","footer":"Section_footer__1KUID","footerInner":"Section_footerInner__1Q4zr"};